import { NEXUS_CRM_INTEGRATION_ARTIFACT_FILE_NAME } from './nexusIntegrationsDemo.js'
import {
  WEBSITE_CRM_CONNECTED_APP_BLOCKS,
  WEBSITE_CRM_DOCUMENTS_TABLE_DATA,
  WEBSITE_CRM_REFINEMENT_CTA_MARKDOWN,
  WEBSITE_CRM_WRAP_UP_MARKDOWN,
} from './websiteCrmDemoContent.part03.js'
import {
  WEBSITE_CRM_APPLICATION_ACCESS_TABLE_DATA,
  WEBSITE_CRM_CONNECT_AFTER_MARKDOWN,
} from './websiteCrmDemoContent.part01.js'
import { WEBSITE_CRM_PROCESS_EXECUTION_TABLE_DATA } from './websiteCrmDemoContent.part02.js'

export function buildWebsiteCrmDocumentArtifactBlocks(htmlArtifactId, zohoArtifactId, docArtifactId) {
  return [
    {
      type: 'fileArtifact',
      fileName: NEXUS_CRM_INTEGRATION_ARTIFACT_FILE_NAME,
      description: 'Markdown',
      artifactKind: 'doc',
      artifactId: zohoArtifactId,
    },
    {
      type: 'fileArtifact',
      fileName: 'NexusB2B — Procurement Site.html',
      description: 'HTML App',
      artifactKind: 'html',
      artifactId: htmlArtifactId,
    },
    {
      type: 'fileArtifact',
      fileName: 'NexusB2B — CRM Test Report.md',
      description: 'Markdown',
      artifactKind: 'doc',
      artifactId: docArtifactId,
    },
  ]
}

export function buildWebsiteCrmDemoClosingBlocks(htmlArtifactId, zohoArtifactId, docArtifactId) {
  return [
    { type: 'markdown', content: WEBSITE_CRM_CONNECT_AFTER_MARKDOWN },
    { type: 'heading', level: 3, content: 'Connected Applications' },
    {
      type: 'markdown',
      variant: 'muted',
      content:
        'All integrations required for RFQ capture, payments, and nurture emails are active in your workspace.',
    },
    ...WEBSITE_CRM_CONNECTED_APP_BLOCKS,
    { type: 'heading', level: 3, content: 'Application Access Summary' },
    { type: 'table', data: WEBSITE_CRM_APPLICATION_ACCESS_TABLE_DATA },
    { type: 'heading', level: 3, content: 'Process Execution & Results' },
    { type: 'table', data: WEBSITE_CRM_PROCESS_EXECUTION_TABLE_DATA },
    { type: 'heading', level: 3, content: 'Documents Generated' },
    { type: 'table', data: WEBSITE_CRM_DOCUMENTS_TABLE_DATA },
    ...buildWebsiteCrmDocumentArtifactBlocks(htmlArtifactId, zohoArtifactId, docArtifactId),
    { type: 'markdown', content: WEBSITE_CRM_WRAP_UP_MARKDOWN },
    { type: 'markdown', content: WEBSITE_CRM_REFINEMENT_CTA_MARKDOWN },
  ]
}
